import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Day.js Timezone 관련 플러그인 활성화
dayjs.extend(utc);
dayjs.extend(timezone);

const StarbeatHistoryCard = ({ item }) => {
  const { t } = useTranslation();

  // 접속 국가에 따른 타임존 설정
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className={`purchase-card table-layout-wrapper ${item.transaction_type === 'use' ? 'type-used-card' : ''}`}>
      <div className='purchase-left-wrapper table-layout-left-wrapper'>
        <div className='purchase-info-group'>
          <div className='purchase-txt-group'>
            <p className={'purchase-title'}>
              {/* 구매 & 웹인 경우만 star_beat_product, 그 외에는 beat 표기 */}
              {/* app의 star_beat_product과 web은 표기 기준 다름 */}
              {item.transaction_type === 'charge' && item.platform === 'web'
                ? item.star_beat_product
                : Math.abs(item.beat).toLocaleString()}{' '}
              {item.transaction_type === 'charge' ? t('star_beat_purchased') : t('star_beats_used')}
              {/* 스타비트 충전인 경우 플랫폼 표기, 소비는 별도 표기 없음 */}
              {item.transaction_type === 'charge' ? (item.platform === 'web' ? '(WEB)' : '(APP)') : null}
            </p>
            {/* 스타비트 사용 시 상품 정보 노출 */}
            {item.transaction_type === 'use' ? <p className={'purchase-info'}>{item.product_name}</p> : null}
            {/* 스타비트 구매 시 이메일 정보 노출, 앱 구매 시 이메일 정보 null일 수 있음 */}
            {item.transaction_type === 'charge' && item.email !== null ? (
              <p className={'purchase-info'}>
                {t('email')} : {item.email}
              </p>
            ) : null}
            {/* 스타비트 구매 시 앱의 경우 app_price, 웹의 경우 price, currency 노출 */}
            {item.transaction_type === 'charge' ? (
              <p className={'purchase-info type-price-info'}>
                {t('product_price')} :{' '}
                {item.platform === 'web'
                  ? `${Math.round(item.price).toLocaleString()} ${item.currency}`
                  : item.app_price}
              </p>
            ) : null}
          </div>
        </div>
      </div>
      <div className='purchase-right-wrapper table-layout-right-wrapper'>
        <div className='purchase-info-group table-layout-center table-layout-content-group mb-hide'>
          <span className='purchase-info-txt'>{dayjs(item.buy_at).tz(timezone).format('YYYY. MM. DD')}</span>
        </div>
        <div className='purchase-info-group table-layout-center table-layout-content-group table-flex-end'>
          <span className={'purchase-info-txt purchase-info-price-txt'}>
            {/* transaction_type에 따라 기호 삽입해주고 기존값 절대값으로 변환 */}
            {item.transaction_type === 'use' ? '-' : '+'} {Math.abs(item.beat).toLocaleString()}
            <span className='star-beat-group'>
              <i className='icon icon-starbeat' />
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default StarbeatHistoryCard;
